var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-cascader',{ref:"menuCascader",staticClass:"el-cascader",attrs:{"clearable":_vm.clearable,"size":_vm.size,"value":_vm.menuId,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"options":_vm.options,"props":{ checkStrictly: true,expandTrigger: 'hover',label:'name',value:'id',children:'children' }},on:{"change":_vm.change}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6caf89f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sui-menu/sui-menu.vue
// module id = null
// module chunks = 